import React, { useState, createContext, useEffect, useContext } from 'react';
import axios from '../Util/axiosConfig';
import { baseUrl } from '../Contants';
import { AppContext } from './AppContextProvide';

export const HubSpokeContext = createContext();

export const HubSpokeContextProvider = ({ children }) => {
  const { user, isLoggedOut } = useContext(AppContext);
  const [spokeList, setSpokeList] = useState([]);
  const [selectedSpoke, setSelectedSpoke] = useState('');

  useEffect(() => {
    async function getSpokeList() {
      const result = await axios(`${baseUrl}/api/hub/spokes`);
      setSpokeList(result.data.spokeList.map((a) => a.name));
    }

    if (user.access_type_cd !== 'a' || isLoggedOut) return;

    getSpokeList();
    // Depend on the primitive access_type_cd, not the whole `user` object — AppContext
    // swaps the user reference on hydrate/token-validation, which refetched spokes.
  }, [isLoggedOut, user?.access_type_cd]);

  return (
    <HubSpokeContext.Provider
      value={{ setSelectedSpoke, spokeList, selectedSpoke }}
    >
      {children}
    </HubSpokeContext.Provider>
  );
};
